/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BriefResource } from './';
import {
    BriefResourceFromJSON,
    BriefResourceFromJSONTyped,
    BriefResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface SubmittedBriefResponse
 */
export interface SubmittedBriefResponse {
    /**
     * 
     * @type {BriefResource}
     * @memberof SubmittedBriefResponse
     */
    value: BriefResource;
    /**
     * 
     * @type {boolean}
     * @memberof SubmittedBriefResponse
     */
    canEditDescription: boolean;
}

/**
 * Check if a given object implements the SubmittedBriefResponse interface.
 */
export function instanceOfSubmittedBriefResponse(value: object): value is SubmittedBriefResponse {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('canEditDescription' in value) || value['canEditDescription'] === undefined) return false;
    return true;
}

export function SubmittedBriefResponseFromJSON(json: any): SubmittedBriefResponse {
    return SubmittedBriefResponseFromJSONTyped(json, false);
}

export function SubmittedBriefResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmittedBriefResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'value': BriefResourceFromJSON(json['value']),
        'canEditDescription': json['canEditDescription'],
    };
}

export function SubmittedBriefResponseToJSON(value?: SubmittedBriefResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': BriefResourceToJSON(value['value']),
        'canEditDescription': value['canEditDescription'],
    };
}

